import React from "react";
import { Link } from "react-router-dom";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import { useAuth } from "../../providers/auth-provider";
import BarChartRoundedIcon from "@mui/icons-material/BarChartRounded";
import OndemandVideoRoundedIcon from "@mui/icons-material/OndemandVideoRounded";
import PaidRoundedIcon from "@mui/icons-material/PaidRounded";
import TableChartRoundedIcon from "@mui/icons-material/TableChartRounded";
import LinkRoundedIcon from "@mui/icons-material/LinkRounded";
import BusinessRoundedIcon from "@mui/icons-material/BusinessRounded";
import SettingsInputAntennaRoundedIcon from "@mui/icons-material/SettingsInputAntennaRounded";
import isAdmin from "../../functions/is-admin";
import hasPermission, { PERMISSIONS } from "../../functions/has-permission";
import SlowMotionVideoRoundedIcon from '@mui/icons-material/SlowMotionVideoRounded';
import AccountBoxRounded from '@mui/icons-material/AccountBoxRounded';

export default function SideBar({ currentPage }) {
  const sidebarData = [
    {
      destination: "/",
      title: "Overview",
      group: "overview",
      icon: <BarChartRoundedIcon />,
      permission: PERMISSIONS.HBBTV_VIEWERSHIP,
    },
    {
      destination: "/performance",
      title: "Performance",
      group: "performance",
      icon: <OndemandVideoRoundedIcon />,
      permission: PERMISSIONS.HBBTV_VIEWERSHIP,
    },
    {
      destination: "/monetisation",
      title: "Monetisation",
      group: "monetisation",
      icon: <PaidRoundedIcon />,
      permission: PERMISSIONS.HBBTV_VIEWERSHIP,
    },
    {
      destination: "/avod",
      title: "AVOD",
      group: "avod",
      icon: <SlowMotionVideoRoundedIcon />,
      permission: PERMISSIONS.AVOD,
    },
    {
      destination: "/one-link-bridge",
      title: "One Link Bridge",
      group: "one-link-bridge",
      icon: <LinkRoundedIcon />,
      permission: PERMISSIONS.ONE_LINK,
    },
    {
      destination: "/reports",
      title: "Reports",
      group: "reports",
      icon: <TableChartRoundedIcon />,
    },
  ];

  const sidebarAdminData = [
    {
      destination: "/admin/organisations",
      title: "Organisations",
      group: "admin-organisations",
      icon: <BusinessRoundedIcon />,
    },
    {
      destination: "/admin/channels",
      title: "Channels",
      group: "admin-channels",
      icon: <SettingsInputAntennaRoundedIcon />,
    },
  ];
  const { user, logout } = useAuth();

  const addClasses = (page) => {
    if (Array.isArray(page)) {
      return page.includes(currentPage) ? "active" : "";
    }

    return page === currentPage ? "active" : "";
  };

  return (
    <ul className="app-sidebar">
      {/* <li className="trigger-area trigger-area--full-width" ref={expandedSpacingRef}></li> */}

      <li className="app-sidebar__item" key="sidebar-header">
        <div className="app-sidebar__header">
          <div className="app-sidebar__header__logo">
            <img src="/images/gstv-icon.png" alt="gstv-icon" />
          </div>

          <div className="app-sidebar__header__text">
            <div className="app-sidebar__header__title">GoSeeTV</div>
            <div className="app-sidebar__header__subtitle">
              Go See TV Insights
            </div>
          </div>
        </div>
      </li>

      {sidebarData
        .filter((sidebarItem) => hasPermission(user, sidebarItem.permission))
        .map((sidebarItem, sIndex) => (
        <li className="app-sidebar__item" key={sIndex}>
          <Link
            to={sidebarItem.destination}
            className={`app-sidebar__link ${addClasses(sidebarItem.group)}`}
          >
            {sidebarItem.icon}
            <span className="app-sidebar__nav-text">{sidebarItem.title}</span>
          </Link>
        </li>
      ))}

      <li className="app-sidebar__divider" key="divider-001"></li>
      {user && isAdmin(user)
        ? sidebarAdminData.map((sidebarItem, sIndex) => (
            <li className="app-sidebar__item" key={`admin-${sIndex}`}>
              <Link
                to={sidebarItem.destination}
                className={`app-sidebar__link ${addClasses(sidebarItem.group)}`}
              >
                {sidebarItem.icon}
                <span className="app-sidebar__nav-text">
                  {sidebarItem.title}
                </span>
              </Link>
            </li>
          ))
        : null}


      <li className="app-sidebar__item">
        <Link
            to={"/account"}
            className={`app-sidebar__link ${addClasses('manage-account')}`}
        >
          <AccountBoxRounded />
          <span className="app-sidebar__nav-text">Account</span>
        </Link>
      </li>

      <li className="app-sidebar__item" key="sidebar-logout">
        <Link
          onClick={(e) => {
            e.preventDefault();
            logout();
          }}
          className="app-sidebar__link"
        >
          <LogoutRoundedIcon />
          <span className="app-sidebar__nav-text">Logout</span>
        </Link>
      </li>
    </ul>
  );
}
